import React from "react"
import {FormattedMessage, FormattedCurrency} from "@irati/utils/lang"
import Alert, {AlertTypes} from "@irati/ui/src/Alert"

interface Props {
  minPrice: number
  currency: string
}

const UnderMinAmount: React.FC<Props> = ({minPrice, currency}) => {
  const formattedMaxPrice = <FormattedCurrency isCents={false} value={minPrice} currency={currency} />
  const text = <FormattedMessage id="perks.components.productForms.underMinAmountV2" values={{value: formattedMaxPrice}} />
  return <Alert nonDismissable type={AlertTypes.warning} title={text} />
}

export default UnderMinAmount
